import type { TextLayout } from '../types';

/**
 * 围绕排版区域中心镜像 Text Layer 宿主的最终视觉区域。
 *
 * Text Render 只负责文字自身的 layout/render box；outer flip 属于真实宿主，
 * Preview 与导出在这里共享同一份坐标变换，避免把宿主状态泄漏进 renderer。
 *
 * @param layout - 未翻转的 Text Layer 宿主布局。
 * @param flipH - 是否水平翻转。
 * @param flipV - 是否垂直翻转。
 * @returns 翻转后的视觉区域和归零偏移；排版区域与尺寸保持不变。
 */
export const applyTextLayoutFlip = (layout: TextLayout, flipH: boolean, flipV: boolean): TextLayout => {
    if (!flipH && !flipV) return layout;

    const { layoutBox, renderBox } = layout;
    const flippedRenderBox = {
        ...renderBox,
        left: flipH ? layoutBox.left * 2 + layoutBox.width - renderBox.left - renderBox.width : renderBox.left,
        top: flipV ? layoutBox.top * 2 + layoutBox.height - renderBox.top - renderBox.height : renderBox.top,
    };

    return {
        ...layout,
        renderBox: flippedRenderBox,
        offset: {
            x: -flippedRenderBox.left,
            y: -flippedRenderBox.top,
        },
    };
};
